import {useState} from 'react'
import Style from './style'
import windowsIcon from 'shared/assets/windows-logo.svg'

const DownloadButton = ({
	small = false,
	fitWidth = false,
	filename = null,
	versionData = null,
}) => {
	const [isDownloading, setIsDownloading] = useState(false)

	const handleDownload = async () => {
		if (!versionData?.data?.download_url || isDownloading) return

		setIsDownloading(true)
		try {
			// Create a temporary anchor element to trigger download
			const link = document.createElement('a')
			link.href = versionData.data.download_url

			// Use custom filename if provided, otherwise use default
			const defaultFilename = `timer-app-v${versionData.data.version}.exe`
			link.download = filename || defaultFilename

			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		} catch (error) {
			console.error('Download failed:', error)
		} finally {
			setIsDownloading(false)
		}
	}

	// Don't render if no version data or no download URL
	if (!versionData?.data?.download_url) return null

	return (
		<Style.Btn
			onClick={handleDownload}
			$small={small}
			$fitWidth={fitWidth}
			$downloading={isDownloading}
			disabled={isDownloading}
		>
			<img src={windowsIcon} alt='windows' />
			<div>
				<div style={{fontSize: '10px', fontWeight: '600', color: '#FFFFFF'}}>
					{isDownloading ? '다운로드 중...' : 'Download for Windows'}
				</div>
				<div
					style={{
						fontSize: '8px',
						fontWeight: '400',
						opacity: 0.9,
						color: '#FFFFFF',
					}}
				>
					{isDownloading
						? ''
						: `Timer App v${versionData.data.version} Installer (.exe)`}
				</div>
			</div>
			{/* <img
				src={downloadArrow}
				alt='download'
				style={{marginLeft: 'auto', filter: 'brightness(0) invert(1)'}}
			/> */}
		</Style.Btn>
	)
}

export default DownloadButton
